// extracted by mini-css-extract-plugin
export default {"inputBox":"GridInputBox_inputBox__S0n9G"};